// utils.js

/**
 * Divise deux nombres et retourne le quotient entier et le reste.
 * @param {number} dividend - Le dividende.
 * @param {number} divisor - Le diviseur.
 * @returns {Object} Un objet contenant le quotient et le reste.
 */
export function divideAndRemainder(dividend, divisor) {
    let quotient = Math.floor(dividend / divisor);
    let remainder = dividend % divisor;
    return { quotient, remainder };
}


/**
 * repartie une somme d'argent en bronze argent et or
 * @param {number} dividend - Le dividende.
 * @returns {Object} Un objet contenant l'argent.
 */
export function moneyMaker(dividend) {
    let or = Math.floor(dividend / 100);
    let reste = dividend % 100;
    let argent = Math.floor(reste / 10);
    let bronze = reste % 10;
    return { or, argent, bronze };
}

/**
 * parse la chaine de retour de grouê d'in personnage
 * @param {number} dividend - Le dividende.
 * @returns {Object} Un objet contenant l'argent.
 */
export function parseGroupString(groupString) {
    return groupString.split('|').map(group => {
        const [id, ...nameParts] = group.split(':');
        const name = nameParts.join(':');
        return {
            idGroupe: parseInt(id.trim(), 10),
            nomGroupe: name.trim()
        };
    });
}
/**
 * Vérifie si un nombre est pair.
 * @param {number} num - Le nombre à vérifier.
 * @returns {boolean} True si le nombre est pair, sinon false.
 */
export function isEven(num) {
    return num % 2 === 0;
}

/**
 * Génère un nombre aléatoire entre min et max.
 * @param {number} min - La valeur minimale.
 * @param {number} max - La valeur maximale.
 * @returns {number} Un nombre aléatoire entre min et max.
 */
export function getRandomNumber(min, max) {
    return Math.floor(Math.random() * (max - min + 1)) + min;
}

// Ajoutez d'autres fonctions utilitaires ici
